import { isError } from 'flux-standard-action';
import { payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { USER_ACCOUNT_STATE_STATUSES } from '../constants';

const requestMutationGenerator = () => ({
  status: { $set: USER_ACCOUNT_STATE_STATUSES.RESETING_PASSWORD },
  error: { $set: null },
});

const successMutationGenerator = () => ({
  status: { $set: USER_ACCOUNT_STATE_STATUSES.NOT_AUTHENTICATED },
  error: { $set: null },
});

const errorMutationGenerator = (error) => ({
  status: { $set: USER_ACCOUNT_STATE_STATUSES.NOT_AUTHENTICATED },
  error: { $set: error },
});

export const userAccountResetPasswordWithTokenRequestReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : requestMutationGenerator)(payloadExtractor(action)),
  );

export const userAccountResetPasswordWithTokenSuccessReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : successMutationGenerator)(payloadExtractor(action)),
  );

export const userAccountResetPasswordWithTokenFailureReducer = (currentState, action) =>
  updateState(currentState, errorMutationGenerator(payloadExtractor(action)));
